import AgeCode from '../ageCode/ageCode';
import ChannelListBlockContainer from '@components/atoms/container/channelListBlockContainer';
import ChannelTitle from '@components/atoms/text/channelListTitle';
import EventInfo from '@components/atoms/container/channelListEventInfoContainer';
import EventTitle from '@components/atoms/container/channelListEventTitleContainer';
import EventUtils from '@shared/utils/events';
import ExtraInfo from '@components/atoms/container/channelListExtraInfoContainer';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import { useContext } from 'react';

export default function ChannelBlock() {
  const { channel, event } = useContext(ChannelListContext);
  return (
    <ChannelListBlockContainer id={'channelListBlockContainer'}>
      <ChannelTitle id={'channelTitle'}>{channel?.title}</ChannelTitle>
      <EventInfo id={'eventInfo'}>{EventUtils.getInfo(event)}</EventInfo>
      <EventTitle id={'eventTitle'}>{event?.title}</EventTitle>
      <EventInfo extraInfo={true} id={'dateEventInfo'}>
        {EventUtils.getDate(event)}
        <ExtraInfo id={'ageCode'}>
          <AgeCode ageCode={event?.ageCode} />
          {/* TBD: Add HD, Dolby and other useful data */}
        </ExtraInfo>
      </EventInfo>
    </ChannelListBlockContainer>
  );
}
